// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gas-item[data-v-86fb8d7e] {\n  padding-top: 18px !important;\n}\n.gas-item .q-field__inner[data-v-86fb8d7e] {\n  padding-bottom: 0px !important;\n}\n.gas-item .customText[data-v-86fb8d7e] {\n  padding-bottom: 0px !important;\n}\n.gas-card-title[data-v-86fb8d7e] {\n  font-size: 15px;\n  font-weight: 800;\n}\n.trans[data-v-86fb8d7e] {\n  margin: -20px 0 10px 10px !important;\n  font-size: 14px;\n}", ""]);
// Exports
module.exports = exports;
